import { render, staticRenderFns } from "./JsNavigationChildrenIr.vue?vue&type=template&id=1f20b494"
import script from "./JsNavigationChildrenIr.vue?vue&type=script&lang=js"
export * from "./JsNavigationChildrenIr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports